import React from "react";
import styled from "styled-components";

import { SIDEBAR_WIDTH } from "../../app/theme";
import Header from "./Header";
import Sidebar from "./Sidebar";

const PageContent = styled.main`
  margin-left: ${SIDEBAR_WIDTH}px;
  padding: 35px 25px 25px;
`;

const Layout = ({ children }) => (
  <>
    <Header />
    <Sidebar />
    <PageContent>{children}</PageContent>
  </>
);

export default Layout;
